import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { BaseURL } from '../../Essentials/variables';
import "./style.scss";
import { default as ReactSelect } from "react-select";
import { components } from "react-select";
import { Hourglass, LineWave } from 'react-loader-spinner';
import { useNotify } from "../../Components/Notifications/NotificationContext";
const UpdatePopup = ({ onClose, onUpdate, profile, requestfrom, id,userIds }) => {
    const notify = useNotify();
    const [name, setName] = useState(profile?.name);
    const [userId, setUserId] = useState(profile?.user_id);
    const [accessLevel, setAccessLevel] = useState(profile?.accesstype);
    const [stateType, setStateType] = useState(profile?.accessname);
    const [mapAccess, setMapAccess] = useState(profile?.access);
    const [AdminAccess, setAdminAccess] = useState(profile?.admin);
    const [potentialAccess, setPotentialAccess] = useState(profile?.potential);
    const [reportAccess, setAccessReport] = useState();
    const [errorPresent, setErrorPresent] = useState(false);
    const [errorValue, setErrorValue] = useState({});
    const [options, setOptions] = useState([]);
    const [suggestions, setSuggestions] = useState([]);
    const [nameSuggestions, setNameSuggestions] = useState([]);
    const [updateLoader, setUpdateLoader] = useState(false);

    const handleNameChange = (event) => {
        // console.log(event.target.value)
        // setName(event.target.value);
        console.log(event.target.value)
        const input = event.target.value;
        setName(input)
        const filteredSuggestions = options.filter((option) => {
            if (input.length > 2) {
                const empName = option?.employee_name?.toString()?.toLowerCase();
                const userInput = input?.toString()?.toLowerCase();
                // console.log(staffId, "--->", userInput);
                return empName?.includes(userInput);
            }
            return false;
        });
        setNameSuggestions(filteredSuggestions);
        setName(event.target.value);
    }
    const handleNameSuggestionClick = (suggestion) => {

        console.log('suggestion click', suggestion);

        // if(!suggestion?.access_type){console.log("Working.......");}

        setUserId(suggestion?.staff_id);

        setName(suggestion?.employee_name);

        setAccessLevel(suggestion?.access_type);

        setStateType(suggestion?.access_name);

        if (!suggestion?.access_type) {

            console.log("Working 2.......");

            setAccessLevel("");

            setStateType("");

        }

        // setUserInput(suggestion);

        setNameSuggestions([]);

    };

    useEffect(() => {
        axios({
            method: 'GET',
            url: BaseURL + 'getallusers',
            headers: {
                'x-access-token': localStorage.getItem('token'),
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'X-Frame-Options': 'DENY',
                'Content-Security-Policy': "frame-ancestors 'none'",
                'Feature-Policy': "frame-ancestors 'none'"
            },
        }).then((userData) => {
            console.log(userData?.data);
            setOptions(userData?.data)
        })
    }, [])

        useEffect(() => {
          const errors = validateInput();

          // Only check for duplicate userId in 'add' mode
          const isAddMode = Object.keys(profile).length === 0;
          if (isAddMode && userId && userIds.includes(userId)) {
            errors.userId = "User already exists.";
            notify.error(
              `User already exists for MSPIN/EMPLOYEE ID: ${userId}!`
            );
          }

          const hasErrors = Object.keys(errors).length > 0;
          setErrorPresent(hasErrors);
          setErrorValue(errors);
        }, [userId, profile, userIds]);


    // ...existing code...

    const handleIdChange = (event) => {
        const input = event.target.value;
        setUserId(input);

        // setUserInput(input);

        const filteredSuggestions = options.filter((option) => {

            if (input.length > 2) {
                const staffId = option?.staff_id?.toString()?.toLowerCase();
                const userInput = input?.toString()?.toLowerCase();
                // console.log(staffId, "--->", userInput);
                return staffId.includes(userInput);
            }
            return false;
        });

        setSuggestions(filteredSuggestions);
        // console.log("Suggestion found :", filteredSuggestions);
        //axios request
    };
    const handleSuggestionClick = (suggestion) => {
        console.log(suggestion);
        // if(!suggestion?.access_type){console.log("Working.......");}
        setUserId(suggestion?.staff_id);
        setName(suggestion?.employee_name);
        setAccessLevel(suggestion?.access_type);
        setStateType(suggestion?.access_name);
        if (!suggestion?.access_type) {
            console.log("Working.......");
            setAccessLevel("");
            setStateType("");
        }
        // setUserInput(suggestion);
        setSuggestions([]);
    };
    let Token = localStorage.getItem('token');

    const handleSubmitButton = () => {

        setUpdateLoader(true);
        axios({
            method: 'post',
            url: BaseURL + 'updateuser/v1',
            headers: {
                'x-access-token': localStorage.getItem('token'),
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'X-Frame-Options': 'DENY',
                'Content-Security-Policy': "frame-ancestors 'none'",
                'Feature-Policy': "frame-ancestors 'none'"
            },
            data: {
                name, // This is the body part
                userId,
                accessLevel,
                stateType,
                mapAccess,
                AdminAccess,
                potentialAccess,
                reportAccess
            }
        }).then(() => {
            setUpdateLoader(false)
            onUpdate(true)
            onClose();
            notify.success(`Data updated successfully for "${name}"!`)
        }).catch(() => {
            setUpdateLoader(false);
            notify.error(`Something went wrong"!`)
        });
    }

    // useEffect(()=>{
    //   console.log(profile);

    // },[])

    const validateInput = () => {
        const errors = {}
        if (!name?.trim()) {
            console.log('name is empty..')
            errors.name = "Name cannot be empty."
        }
        else if (!/^[a-zA-Z.\s]+$/.test(name)) {
            errors.name = 'Name can only contain alphabets and spaces'
        }

        if (!userId?.trim()) {
            errors.userId = "User Id cannot be empty."
        } else if (!/^[a-zA-Z0-9_]+$/.test(userId)) {
            errors.userId = 'User Id can only contain alphabets, numbers and underscore';
        } else {
            // Only check for duplicate userId in 'add' mode
            const isAddMode = Object.keys(profile).length === 0;
            if (isAddMode && userId && userIds.includes(userId)) {
                errors.userId = "User already exists.";
            }
        }

        return errors;
    }

    const handleSubmit = (event) => {
        event.preventDefault();
        // onUpdate({ name , email });
        // onClose();
        console.log(name, " ", userId, " ", accessLevel, " ", stateType, " ", mapAccess, " ", AdminAccess, " ", potentialAccess);
    };
    const Option = (props) => {
        return (
            <div>
                <components.Option {...props}>
                    <input
                        type="checkbox"
                        checked={props.isSelected}
                        onChange={() => null}
                    />{" "}
                    <label>{props.label}</label>
                </components.Option>
            </div>
        );
    };



    return (<div className=' bg-none ' style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: 'auto' }}>

        <LineWave
            visible={updateLoader}
            height="200"
            width="200"
            ariaLabel="hourglass-loading"
            wrapperStyle={{}}
            wrapperClass=""
            color='#171b8f'
        />
        {updateLoader === true && <h1>Updating Data...</h1>}
        {updateLoader === false && <form className="w-auto bg-slate-100 max-w-lg justify-center border border-red-300 shadow-lg rounded-lg p-4" onSubmit={handleSubmit}>
            <div class="flex flex-wrap -mx-3 mb-6">
                <div class="w-full md:w-1/2 px-3 mb-6 md:mb-0">
                    <label class="block uppercase tracking-wide text-black-900 text-xs font-bold mb-2">
                        Name
                    </label>
                    <input onChange={handleNameChange} class="appearance-none block w-full bg-gray-200 text-gray-700 border border-red-500 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white" id="grid-first-name" type="text" value={name} />
                    {errorValue && errorValue.name && <span style={{ 'color': 'red' }}>{errorValue.name}</span>}

                    {name && nameSuggestions.length > 0 && (

                        <ul className="custom-select-options">
                            {nameSuggestions.map((suggestion, index) => (
                                <li key={index} onClick={() => handleNameSuggestionClick(suggestion)}>
                                    {suggestion?.employee_name} [{suggestion?.dept}]
                                </li>
                            ))}
                        </ul>
                    )}

                </div>
                <div class="w-full md:w-1/2 px-3 custom-select">
                    <label class="block uppercase tracking-wide text-black-900 text-xs font-bold mb-2">
                        MSPIN/EMPLOYEE ID
                    </label>
                    {/* <input onChange={handleIdChange} class="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500" id="grid-last-name" type="text"value={(profile?.user_id)?profile?.user_id:id }/> */}
                    <input disabled={Object.keys(profile).length > 0} onChange={handleIdChange} class="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500" id="grid-last-name" type="text" value={userId} />
                    {errorValue && errorValue.userId && <span style={{ 'color': 'red' }}>{errorValue.userId}</span>}
                    {userId && suggestions.length > 0 && (
                        <ul className="custom-select-options">
                            {suggestions.map((suggestion, index) => (
                                <li key={index} onClick={() => handleSuggestionClick(suggestion)}>
                                    {suggestion?.staff_id}
                                </li>
                            ))}
                        </ul>
                    )}

                </div>
            </div>

            <div class="flex flex-wrap -mx-3 mb-6">
                <div class="w-full md:w-1/2 px-3 mb-6 md:mb-0">
                    <label class="block uppercase tracking-wide text-black-900 text-xs font-bold mb-2">
                        ACCESS LEVEL
                    </label>
                    <div class="relative">
                        <select value={accessLevel} onChange={(e) => { setAccessLevel(e.target.value) }} class="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500" id="grid-state">
                            <option key={profile?.accesstype} value={profile?.accesstype}>Select level type</option>
                            <option key='HO' value='HO'>HO</option>
                            <option key='Zone' value='Zone'>Zone</option>
                            <option key='Region' value='Region'>Region</option>
                            {/* <option key='Dealer' value='Dealer'>Dealer</option> */}
                        </select>
                        <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                            <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" /></svg>
                        </div>
                    </div>
                </div>
                <div class="w-full md:w-1/2 px-3">
                    <label class="block uppercase tracking-wide text-black-900 text-xs font-bold mb-2">
                        STATE/TYPE
                    </label>
                    <div class="relative">
                        {/* //////////Different Dropdowns for different selections//////// */}
                        {accessLevel === '' && <select value={stateType} onChange={(e) => { setStateType(e.target.value) }} class="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500" id="grid-state">
                            <option key={profile?.accessname} value={profile?.accessname}>Please select level</option>
                        </select>}
                        {accessLevel === 'HO' && <select value={stateType} onChange={(e) => { setStateType(e.target.value) }} class="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500" id="grid-state">
                            <option key={profile.accessname} value={profile.accessname}>Select area</option>
                            <option key='HO' value='HO'>HO</option>
                        </select>}
                        {accessLevel === 'Zone' && <select value={stateType} onChange={(e) => { setStateType(e.target.value) }} class="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500" id="grid-state">
                            <option key={profile.accessname} value={profile.accessname}>Select area</option>
                            <option key='South' value='South'>SOUTH</option>
                            <option key='East' value='East'>EAST</option>
                            <option key='North' value='North'>NORTH</option>
                            <option key='West' value='West'>WEST</option>
                            <option key='Central' value='Central'>CENTRAL</option>
                            <option key='South East' value='South East'>SOUTH EAST</option>
                        </select>}
                        {accessLevel === 'Region' && <select value={stateType} onChange={(e) => { setStateType(e.target.value) }} class="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500" id="grid-state">
                            <option key={profile.accessname} value={profile.accessname}>Select area</option>
                            <option key='CENTRAL 1' value='CENTRAL 1'>CENTRAL 1</option>
                            <option key='CENTRAL 2' value='CENTRAL 2'>CENTRAL 2</option>
                            <option key='CENTRAL 3' value='CENTRAL 3'>CENTRAL 3</option>
                            <option key='CENTRAL 4' value='CENTRAL 4'>CENTRAL 4</option>
                            <option key='EAST 1' value='EAST 1'>EAST 1</option>
                            <option key='EAST 2' value='EAST 2'>EAST 2</option>
                            <option key='EAST 3' value='EAST 3'>EAST 3</option>
                            <option key='NORTH 1' value='NORTH 1'>NORTH 1</option>
                            <option key='NORTH 2' value='NORTH 2'>NORTH 2</option>
                            <option key='NORTH 3' value='NORTH 3'>NORTH 3</option>
                            <option key='NORTH 4' value='NORTH 4'>NORTH 4</option>
                            <option key='SOUTH 1' value='SOUTH 1'>SOUTH 1</option>
                            <option key='SOUTH 2' value='SOUTH 2'>SOUTH 2</option>
                            <option key='SOUTH 3' value='SOUTH 3'>SOUTH 3</option>
                            <option key='SOUTH EAST 1' value='SOUTH EAST 1'>SOUTH EAST 1</option>
                            <option key='SOUTH EAST 2' value='SOUTH EAST 2'>SOUTH EAST 2</option>
                            <option key='WEST 1' value='WEST 1'>WEST 1</option>
                            <option key='WEST 2' value='WEST 2'>WEST 2</option>
                            <option key='WEST 3' value='WEST 3'>WEST 3</option>
                        </select>}

                        <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                            <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" /></svg>
                        </div>
                    </div>
                </div>
            </div>






            {requestfrom === 'admin' && <div class="flex flex-wrap -mx-3 mb-2">
                <div class="w-full md:w-1/3 px-3 mb-6 md:mb-0">
                    <label class="block uppercase tracking-wide text-black-900 text-xs font-bold mb-2" for="grid-city">
                        COVERAGE
                    </label>
                    <div class="relative">
                        <select onChange={(e) => { setMapAccess(e.target.value) }} class="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500" id="grid-state">
                            {/* <option key={profile.access} value={profile.access}>{profile.access}</option> */}
                            <option key='No' value='No'>No</option>
                            <option key='Yes' value='Yes'>Yes</option>
                        </select>
                        <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                            <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" /></svg>
                        </div>
                    </div>
                </div>
                <div class="w-full md:w-1/3 px-3 mb-6 md:mb-0">
                    <label class="block uppercase tracking-wide text-black-900 text-xs font-bold mb-2" for="grid-state">
                        ADMIN
                    </label>
                    <div class="relative">
                        <select onChange={(e) => { setAdminAccess(e.target.value) }} class="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500" id="grid-state">
                            {/* <option key={profile.admin} value={profile.admin}>{profile.admin}</option> */}
                            <option key='No' value='No'>No</option>
                            <option key='Yes' value='Yes'>Yes</option>
                        </select>
                        <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                            <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" /></svg>
                        </div>
                    </div>
                </div>
                <div class="w-full md:w-1/3 px-3 mb-6 md:mb-0">
                    <label class="block uppercase tracking-wide text-black-900 text-xs font-bold mb-2" for="grid-zip">
                        POTENTIAL
                    </label>
                    <div class="relative">
                        <select onChange={(e) => { setPotentialAccess(e.target.value) }} class="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500" id="grid-state">
                            {/* <option key={profile.potential} value={profile.potential}>{profile.potential}</option> */}
                            <option key='No' value='No'>No</option>
                            <option key='Yes' value='Yes'>Yes</option>
                        </select>
                        <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                            <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" /></svg>
                        </div>
                    </div>
                </div>
                <div class="w-full md:w-1/3 px-3 mb-6 md:mb-0">
                    <label class="block uppercase tracking-wide text-black-900 text-xs font-bold mb-2" for="grid-zip">
                        REPORT
                    </label>
                    <div class="relative">
                        <select onChange={(e) => { setAccessReport(e.target.value) }} class="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500" id="grid-state">
                            {/* <option key={profile.potential} value={profile.potential}>{profile.potential}</option> */}
                            <option key='No' value='No'>No</option>
                            <option key='Yes' value='Yes'>Yes</option>
                        </select>
                        <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                            <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" /></svg>
                        </div>
                    </div>
                </div>
            </div>}
            <div className="form-group text-center align-middle pb-16">
                <button onClick={handleSubmitButton} className='bg-blue-800 hover:bg-blue-900 text-white mt-2 py-2 px-4 mx-2 rounded' type="submit" disabled={errorPresent || updateLoader}>Submit</button>
                <button className='bg-blue-800 hover:bg-blue-900 text-white mt-2 py-2 px-4 mx-2 rounded' type="button" onClick={onClose}>Cancel</button>
            </div>
        </form>}
    </div>
    );
};

export default UpdatePopup;